import React from 'react';
import { AuthProvider, UsersProvider } from 'contexts';
import EditUser from './EditUser';

export default (props) => {
  return (
    <AuthProvider>
      <UsersProvider>
        <EditUser/>
      </UsersProvider>
    </AuthProvider>
  );
};
